/* GENERATED FILE - do not edit here.
 * source: om-mushrooms ops/quiz/engine/quiz-engine.js
 * sha256: 289ed416e51449d05009188a36121db9d4fb23ed9a14ee80aff3ed1329cb05af
 * regenerate: python3 ops/quiz/cli.py sync-asset (check: cli.py check --theme)
 */
/* ============================================================================
 * ops/quiz/engine/quiz-engine.js - the Find Your Match quiz ENGINE
 * ----------------------------------------------------------------------------
 * WHAT IT DOES
 *   Walks a shopper through the interview and turns their answers into up to
 *   three ranked product recommendations, each with its own reason. It is ONE
 *   pure module: no page access, no network, no storage, no clock, no random
 *   numbers. Given the same compiled content and the same answers it returns
 *   byte-identical output, in the browser and under Node alike.
 *
 *   It is the only place the ranking exists (architecture ADR-4). The Python
 *   compiler never re-implements it; it shells Node against this exact file
 *   (quiz-engine.selftest.js --sweep) to prove the result invariants before any
 *   content can publish. Two definitions of one ranking is how tiers drift.
 *
 * HOW TO USE
 *   Browser: include the file; it defines window.OmQuiz.
 *   Node:    var OmQuiz = require("./quiz-engine.js");
 *
 *     var ladder  = OmQuiz.loadLadder({content: c, content_prev: p, pointer: ptr});
 *     var session = OmQuiz.create({content: ladder.content, entryPoint: "nav",
 *                                  responseId: "qr1.xxxxxxxxxxxxxxxxxxxxxx"});
 *     session.state            -> {phase, question, canGoBack, progressHint, ...}
 *     session.answer(qid, [optionIds]) -> state   (never throws; bad input -> state.error)
 *     session.back()           -> state
 *     session.completeGate({given: true|false}) -> state
 *     session.result           -> the result model (architecture section C9)
 *     OmQuiz.resolveReturn(view, content) -> the model for an emailed-link
 *                                 return, rebuilt from the stored result's ids
 *                                 (om_quiz.return/v1: no answers, no readback)
 *
 *   Everything with a side effect (the visitor id, telemetry, the cart write,
 *   the completion write) lives in quiz-client.js, never here.
 *
 * WHEN TO CHANGE IT
 *   When the ranking POLICY changes shape (the numbers themselves are content
 *   in ops/quiz/content/config.yml and never need a code change), or when the
 *   compiled content schema moves to v2. After any edit: run
 *   `bash ops/quiz/tests/run_all.sh`, then `python3 ops/quiz/cli.py sync-asset`
 *   so the theme copy carries the new hash (check --theme fails until you do).
 *
 * THE CONSTRAINTS THIS FILE ENFORCES (architecture "five constraints")
 *   - No model call and no network at all: the result path is pure computation.
 *   - The quiz fails OPEN: loadLadder and create never throw to the page; a bad
 *     content document degrades to the previous version, then to 'unavailable'.
 *   - Confidence is an integer 0-100 and every comparison is integer math, so
 *     two browsers can never rank the same answers differently.
 *   - No bundle can be recommended: the compiled table contains none, and the
 *     engine only ever returns rows from that table.
 *
 * DEPENDENCIES
 *   None. ES5-compatible on purpose (house style, no build step).
 * ========================================================================== */

(function (root) {
  "use strict";

  // ---------------------------------------------------------------------------
  // Versions. The engine refuses content whose schema it does not speak, which
  // is what lets the fail-open ladder fall back instead of rendering garbage.
  // ---------------------------------------------------------------------------
  // 1.1.0 (build 2): the return visit is rebuilt from the stored result's ids
  // only (validation F-002). Ranking is unchanged from 1.0.0.
  // 1.2.0 (2026-09-24 decisions): Master Blend ranks on its own label and is
  // otherwise offered as `start_broad`; the ritual pick (Coffee Booster for the
  // coffee moment) is always added; a caution line on every result and a label
  // warning on the cards that carry one; no "take all three" (add_all is gone);
  // a return visit counts the cards it dropped and reads an expired link.
  // 1.3.0 (wi-2026-1054, the v1 content's approved slots): every card carries its
  // product's per-format FIT line (`fit`, from the optional `fit_ref`) beside the
  // claim line; the start_broad block picks the foundation line for the shopper's
  // top need (`foundation_reasons`, plain `foundation_reason` as the fallback);
  // and an option may add a SECONDARY need (`add_secondary_need`) whose best
  // product takes one card, basis "secondary", after the top need's cards
  // (never evicting the only top-need card); and a card may link a sibling
  // format (`also_as`: Coffee Booster -> Lion's Mane powder); a foundation card's
  // fit line is its need-aware foundation line; and a card whose row names a
  // `label_line_ref` carries that label line (`label_line`), which is how the
  // start_broad block shows Master Blend's label line beside its foundation
  // line. Content without these keys ranks
  // exactly as 1.2.0 did.
  var ENGINE_VERSION = "1.4.0";
  var CONTENT_SCHEMA = "om_quiz.content/v1";
  var RESULT_SCHEMA = "om_quiz.result/v1";
  var STAGES = ["triage", "differential", "boundary", "fit"];
  var EFFECT_ORDER = ["select_needs", "set_top_need", "set_facet", "set_moments",
                      "set_experience", "advice", "exclude_product_tags", "add_secondary_need"];

  // ---------------------------------------------------------------------------
  // Errors. ContentError is thrown only by load(); loadLadder() catches it, so
  // it never reaches a shopper's page.
  // ---------------------------------------------------------------------------
  function ContentError(code, message) {
    this.name = "ContentError";
    this.code = code;
    this.message = message || code;
  }
  ContentError.prototype = Object.create(Error.prototype);
  ContentError.prototype.constructor = ContentError;

  // ===========================================================================
  // SHA-256 + canonical JSON
  //
  // The content version is sha256(canonical JSON of the payload)[:12], computed
  // by the Python compiler. The engine recomputes it on load so a hand-edited or
  // half-published document is detected in the browser and the ladder falls
  // back to the last good version. Canonical JSON = keys sorted, no whitespace,
  // strings escaped exactly as JSON.stringify does (which matches Python's
  // json.dumps(sort_keys=True, separators=(",",":"), ensure_ascii=False) for
  // every string the compiler can emit; a parity test pins it).
  // ===========================================================================

  var SHA_K = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
  ];

  // Encode a JS string as UTF-8 bytes. TextEncoder where it exists (every
  // modern browser and Node); a hand-rolled encoder otherwise.
  function utf8Bytes(str) {
    if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(str);
    var out = [];
    for (var i = 0; i < str.length; i++) {
      var c = str.charCodeAt(i);
      if (c < 0x80) { out.push(c); }
      else if (c < 0x800) { out.push(0xc0 | (c >> 6), 0x80 | (c & 63)); }
      else if (c >= 0xd800 && c < 0xdc00 && i + 1 < str.length &&
               str.charCodeAt(i + 1) >= 0xdc00 && str.charCodeAt(i + 1) < 0xe000) {
        var cp = 0x10000 + ((c - 0xd800) << 10) + (str.charCodeAt(i + 1) - 0xdc00);
        i++;
        out.push(0xf0 | (cp >> 18), 0x80 | ((cp >> 12) & 63), 0x80 | ((cp >> 6) & 63), 0x80 | (cp & 63));
      } else { out.push(0xe0 | (c >> 12), 0x80 | ((c >> 6) & 63), 0x80 | (c & 63)); }
    }
    return out;
  }

  function sha256Hex(str) {
    var bytes = utf8Bytes(str);
    var n = bytes.length;
    // Pad: 0x80, zeros, then the 64-bit big-endian bit length.
    var total = ((n + 9 + 63) >> 6) << 6;
    var msg = new Array(total);
    var i;
    for (i = 0; i < n; i++) msg[i] = bytes[i];
    msg[n] = 0x80;
    for (i = n + 1; i < total; i++) msg[i] = 0;
    var bitLenHi = Math.floor((n * 8) / 0x100000000);
    var bitLenLo = (n * 8) >>> 0;
    msg[total - 8] = (bitLenHi >>> 24) & 255; msg[total - 7] = (bitLenHi >>> 16) & 255;
    msg[total - 6] = (bitLenHi >>> 8) & 255;  msg[total - 5] = bitLenHi & 255;
    msg[total - 4] = (bitLenLo >>> 24) & 255; msg[total - 3] = (bitLenLo >>> 16) & 255;
    msg[total - 2] = (bitLenLo >>> 8) & 255;  msg[total - 1] = bitLenLo & 255;

    var h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
    var h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
    var w = new Array(64);
    for (var off = 0; off < total; off += 64) {
      var t;
      for (t = 0; t < 16; t++) {
        var j = off + t * 4;
        w[t] = ((msg[j] << 24) | (msg[j + 1] << 16) | (msg[j + 2] << 8) | msg[j + 3]) >>> 0;
      }
      for (t = 16; t < 64; t++) {
        var x = w[t - 15], y = w[t - 2];
        var s0 = ((x >>> 7) | (x << 25)) ^ ((x >>> 18) | (x << 14)) ^ (x >>> 3);
        var s1 = ((y >>> 17) | (y << 15)) ^ ((y >>> 19) | (y << 13)) ^ (y >>> 10);
        w[t] = (w[t - 16] + s0 + w[t - 7] + s1) >>> 0;
      }
      var a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7;
      for (t = 0; t < 64; t++) {
        var S1 = ((e >>> 6) | (e << 26)) ^ ((e >>> 11) | (e << 21)) ^ ((e >>> 25) | (e << 7));
        var ch = (e & f) ^ (~e & g);
        var t1 = (h + S1 + ch + SHA_K[t] + w[t]) >>> 0;
        var S0 = ((a >>> 2) | (a << 30)) ^ ((a >>> 13) | (a << 19)) ^ ((a >>> 22) | (a << 10));
        var maj = (a & b) ^ (a & c) ^ (b & c);
        var t2 = (S0 + maj) >>> 0;
        h = g; g = f; f = e; e = (d + t1) >>> 0; d = c; c = b; b = a; a = (t1 + t2) >>> 0;
      }
      h0 = (h0 + a) >>> 0; h1 = (h1 + b) >>> 0; h2 = (h2 + c) >>> 0; h3 = (h3 + d) >>> 0;
      h4 = (h4 + e) >>> 0; h5 = (h5 + f) >>> 0; h6 = (h6 + g) >>> 0; h7 = (h7 + h) >>> 0;
    }
    var hs = [h0, h1, h2, h3, h4, h5, h6, h7], hex = "";
    for (i = 0; i < 8; i++) hex += ("00000000" + hs[i].toString(16)).slice(-8);
    return hex;
  }

  // Canonical JSON: sorted keys, no whitespace. Only the value types the
  // compiler emits exist in content (no floats: confidence is an integer).
  function canonicalJson(v) {
    if (v === null || v === undefined) return "null";
    var t = typeof v;
    if (t === "boolean") return v ? "true" : "false";
    if (t === "number") {
      if (!isFinite(v)) throw new ContentError("non_finite_number", "non-finite number in content");
      return String(v);
    }
    if (t === "string") return JSON.stringify(v);
    if (Object.prototype.toString.call(v) === "[object Array]") {
      var parts = [];
      for (var i = 0; i < v.length; i++) parts.push(canonicalJson(v[i]));
      return "[" + parts.join(",") + "]";
    }
    var keys = Object.keys(v).sort();
    var out = [];
    for (var k = 0; k < keys.length; k++) {
      if (v[keys[k]] === undefined) continue;
      out.push(JSON.stringify(keys[k]) + ":" + canonicalJson(v[keys[k]]));
    }
    return "{" + out.join(",") + "}";
  }

  // The hash of a content document = sha256 of its canonical form WITHOUT the
  // `version` field (the version is derived from the rest, so it cannot be
  // part of its own input).
  function contentHash(doc) {
    var payload = {};
    var keys = Object.keys(doc);
    for (var i = 0; i < keys.length; i++) if (keys[i] !== "version") payload[keys[i]] = doc[keys[i]];
    return sha256Hex(canonicalJson(payload));
  }

  // ===========================================================================
  // Small pure helpers.
  // ===========================================================================
  function has(o, k) { return o != null && Object.prototype.hasOwnProperty.call(o, k); }
  function isArr(v) { return Object.prototype.toString.call(v) === "[object Array]"; }
  function copyArr(a) { return a ? a.slice() : []; }
  function contains(list, v) { for (var i = 0; i < list.length; i++) if (list[i] === v) return true; return false; }
  function cmpStr(a, b) { return a < b ? -1 : (a > b ? 1 : 0); }
  function orderedBy(list, orderMap) {
    // Stable sort of ids by an order map; unknown ids sort last, then by id.
    return list.slice().sort(function (a, b) {
      var oa = has(orderMap, a) ? orderMap[a] : 1e9, ob = has(orderMap, b) ? orderMap[b] : 1e9;
      return oa !== ob ? oa - ob : cmpStr(a, b);
    });
  }

  // ===========================================================================
  // Content index: the lookup tables built once per compiled content payload. Building
  // it doubles as a structural check - a dangling reference throws here, inside
  // load(), where the ladder can catch it.
  // ===========================================================================
  function indexContent(c) {
    if (!c || typeof c !== "object") throw new ContentError("malformed", "content is not an object");
    if (!isArr(c.questions) || !isArr(c.products) || !isArr(c.needs) || !c.config || !c.fragments) {
      throw new ContentError("malformed", "content is missing a required section");
    }
    var ix = {
      c: c, cfg: c.config, frags: c.fragments,
      questions: c.questions, qById: {}, qIndex: {}, optById: {}, optQuestion: {}, optOrder: {},
      needById: {}, needOrder: {}, facetById: {}, facetOrder: {}, momentOrder: {}, momentById: {},
      products: c.products, prodById: {}, famById: {}, famDefault: {},
      whys: {},
      predicateOptions: {}
    };
    var i, j;
    for (i = 0; i < c.needs.length; i++) {
      ix.needById[c.needs[i].id] = c.needs[i];
      ix.needOrder[c.needs[i].id] = i;
    }
    var facets = c.facets || [];
    for (i = 0; i < facets.length; i++) { ix.facetById[facets[i].id] = facets[i]; ix.facetOrder[facets[i].id] = i; }
    var moments = c.moments || [];
    for (i = 0; i < moments.length; i++) { ix.momentById[moments[i].id] = moments[i]; ix.momentOrder[moments[i].id] = i; }
    var fams = c.families || [];
    for (i = 0; i < fams.length; i++) { ix.famById[fams[i].id] = fams[i]; ix.famDefault[fams[i].id] = fams[i].default_product || null; }
    for (i = 0; i < c.products.length; i++) ix.prodById[c.products[i].id] = c.products[i];
    // 1.4.0: the approved "why" paragraphs, by product|position|need.
    var ws = c.whys || [];
    for (var wi = 0; wi < ws.length; wi++) {
      var wk = ws[wi].product + "|" + ws[wi].position + "|" + ws[wi].need;
      (ix.whys[wk] = ix.whys[wk] || []).push(ws[wi]);
    }
    var ord = 0;
    for (i = 0; i < c.questions.length; i++) {
      var q = c.questions[i];
      if (has(ix.qById, q.id)) throw new ContentError("malformed", "duplicate question " + q.id);
      ix.qById[q.id] = q; ix.qIndex[q.id] = i;
      if (!isArr(q.options)) throw new ContentError("malformed", "question without options " + q.id);
      for (j = 0; j < q.options.length; j++) {
        var o = q.options[j];
        ix.optById[o.id] = o; ix.optQuestion[o.id] = q.id; ix.optOrder[o.id] = ord++;
      }
    }
    // Every option id a predicate mentions: the sweep uses this to know which
    // parts of a shopper's history can change what they are asked next.
    for (i = 0; i < c.questions.length; i++) {
      collectPredicateOptions(c.questions[i].ask_if, ix.predicateOptions);
      for (j = 0; j < c.questions[i].options.length; j++) {
        collectPredicateOptions(c.questions[i].options[j].show_if, ix.predicateOptions);
      }
    }
    // Reference checks the page would otherwise trip over mid-interview.
    for (i = 0; i < c.questions.length; i++) {
      var qq = c.questions[i];
      if (qq.need && !has(ix.needById, qq.need)) throw new ContentError("malformed", "unknown need on " + qq.id);
      if (qq.next && qq.next !== "end" && !has(ix.qById, qq.next)) throw new ContentError("malformed", "dangling next on " + qq.id);
      for (j = 0; j < qq.options.length; j++) {
        var oo = qq.options[j];
        if (oo.next && oo.next !== "end" && !has(ix.qById, oo.next)) throw new ContentError("malformed", "dangling next on " + oo.id);
      }
    }
    for (i = 0; i < c.products.length; i++) {
      var p = c.products[i];
      if (!has(ix.famById, p.family)) throw new ContentError("malformed", "product without a known family " + p.id);
    }
    return ix;
  }

  function collectPredicateOptions(pred, out) {
    if (!pred || typeof pred !== "object") return;
    var k, i;
    if (isArr(pred.any_selected)) for (i = 0; i < pred.any_selected.length; i++) out[pred.any_selected[i]] = true;
    if (isArr(pred.none_selected)) for (i = 0; i < pred.none_selected.length; i++) out[pred.none_selected[i]] = true;
    var subs = [];
    if (isArr(pred.all)) subs = subs.concat(pred.all);
    if (isArr(pred.any)) subs = subs.concat(pred.any);
    if (pred.not) subs.push(pred.not);
    for (k = 0; k < subs.length; k++) collectPredicateOptions(subs[k], out);
  }

  function fragText(ix, id) {
    if (!id) return "";
    var f = ix.frags[id];
    return (f && typeof f.text === "string") ? f.text : "";
  }

  // ===========================================================================
  // Traversal - a pure state machine. A state is a plain object; every step
  // returns a NEW state (copy on write), which is what makes back() a replay
  // and the sweep a simple depth-first search.
  // ===========================================================================
  function initialState() {
    return { answers: [], selected: {}, needs: [], topNeedExplicit: null, facets: [],
             moments: [], experience: null, advice: [], excludedTags: [], secondaryNeeds: [],
             pos: -1, jump: null, ended: false };
  }

  function cloneState(s) {
    var sel = {}, k;
    for (k in s.selected) if (has(s.selected, k)) sel[k] = true;
    return { answers: s.answers.slice(), selected: sel, needs: copyArr(s.needs),
             topNeedExplicit: s.topNeedExplicit, facets: copyArr(s.facets), moments: copyArr(s.moments),
             experience: s.experience, advice: copyArr(s.advice), excludedTags: copyArr(s.excludedTags),
             secondaryNeeds: copyArr(s.secondaryNeeds), pos: s.pos, jump: s.jump, ended: s.ended };
  }

  // The top need: the shopper's explicit "fix first" pick, else (one need, or
  // no pick question) the first selected need in content order. Deterministic.
  function topNeed(ix, s) {
    if (s.topNeedExplicit && contains(s.needs, s.topNeedExplicit)) return s.topNeedExplicit;
    return s.needs.length ? orderedBy(s.needs, ix.needOrder)[0] : null;
  }

  function evalPred(ix, s, pred) {
    if (!pred) return true;
    var i;
    if (isArr(pred.any_selected)) {
      var hit = false;
      for (i = 0; i < pred.any_selected.length; i++) if (s.selected[pred.any_selected[i]]) hit = true;
      if (!hit) return false;
    }
    if (isArr(pred.none_selected)) {
      for (i = 0; i < pred.none_selected.length; i++) if (s.selected[pred.none_selected[i]]) return false;
    }
    if (typeof pred.needs_count_gt === "number" && !(s.needs.length > pred.needs_count_gt)) return false;
    if (isArr(pred.top_need_in) && !contains(pred.top_need_in, topNeed(ix, s))) return false;
    if (isArr(pred.all)) for (i = 0; i < pred.all.length; i++) if (!evalPred(ix, s, pred.all[i])) return false;
    if (isArr(pred.any)) {
      var any = false;
      for (i = 0; i < pred.any.length; i++) if (evalPred(ix, s, pred.any[i])) any = true;
      if (!any) return false;
    }
    if (pred.not && evalPred(ix, s, pred.not)) return false;
    return true;
  }

  // Which options of a question the shopper can see right now. A top_pick
  // question (Decision 4, "which would you fix first") shows back ONLY the
  // needs the shopper picked - never the whole list.
  function visibleOptions(ix, s, q) {
    var out = [];
    for (var i = 0; i < q.options.length; i++) {
      var o = q.options[i];
      if (q.kind === "top_pick") {
        var need = o.effects ? o.effects.set_top_need : null;
        if (!need || !contains(s.needs, need)) continue;
      }
      if (o.show_if && !evalPred(ix, s, o.show_if)) continue;
      out.push(o);
    }
    return out;
  }

  // Branch isolation (Decision 3, PT-2) lives HERE, structurally: a question
  // scoped to a need is asked only when that need is the shopper's top need.
  // Someone who picks focus can never be served a sleep question.
  function questionEligible(ix, s, q) {
    if (q.stage === "differential" && !q.need) return false;
    if (q.need && topNeed(ix, s) !== q.need) return false;
    if (q.ask_if && !evalPred(ix, s, q.ask_if)) return false;
    var vis = visibleOptions(ix, s, q);
    if (vis.length === 0) return false;
    // Decision 4 / SP-1: the "fix first" question is skipped for a one-need shopper.
    if (q.kind === "top_pick" && vis.length < 2) return false;
    return true;
  }

  function nextQuestion(ix, s) {
    if (s.ended) return null;
    var start = s.pos + 1;
    if (s.jump) start = has(ix.qIndex, s.jump) ? ix.qIndex[s.jump] : ix.questions.length;
    for (var i = start; i < ix.questions.length; i++) {
      if (questionEligible(ix, s, ix.questions[i])) return ix.questions[i];
    }
    return null;
  }

  function addUnique(list, v) { if (!contains(list, v)) list.push(v); }

  // Apply one answer. Returns {state} on success or {error} - never throws, so
  // a page bug can never strand a shopper mid-interview (fail open).
  function applyAnswer(ix, s, questionId, optionIds) {
    var q = nextQuestion(ix, s);
    if (!q || q.id !== questionId) return { error: { code: "not_current", message: "that is not the current question" } };
    if (!isArr(optionIds) || optionIds.length === 0) return { error: { code: "no_selection", message: "pick at least one option" } };
    var vis = visibleOptions(ix, s, q), visMap = {}, i;
    for (i = 0; i < vis.length; i++) visMap[vis[i].id] = vis[i];
    var picked = {}, chosen = [];
    for (i = 0; i < optionIds.length; i++) {
      var id = optionIds[i];
      if (!has(visMap, id)) return { error: { code: "bad_option", message: "option not available: " + id } };
      if (!picked[id]) { picked[id] = true; chosen.push(visMap[id]); }
    }
    if (q.kind !== "multi" && chosen.length !== 1) return { error: { code: "single_only", message: "pick exactly one" } };
    if (q.kind === "multi") {
      if (q.max_select && chosen.length > q.max_select) return { error: { code: "too_many", message: "too many picks" } };
      if (chosen.length > 1) {
        for (i = 0; i < chosen.length; i++) {
          if (chosen[i].exclusive) return { error: { code: "exclusive", message: "that option cannot be combined" } };
        }
      }
    }
    // Effects are applied in CONTENT order, never click order, so the same set
    // of picks always produces the same state (PT-1 determinism).
    chosen.sort(function (a, b) { return ix.optOrder[a.id] - ix.optOrder[b.id]; });
    var n = cloneState(s);
    for (i = 0; i < chosen.length; i++) applyEffects(ix, n, chosen[i].effects || {});
    n.needs = orderedBy(n.needs, ix.needOrder);
    n.facets = orderedBy(n.facets, ix.facetOrder);
    n.moments = orderedBy(n.moments, ix.momentOrder);
    n.excludedTags = n.excludedTags.slice().sort(cmpStr);
    var optIds = [];
    for (i = 0; i < chosen.length; i++) { optIds.push(chosen[i].id); n.selected[chosen[i].id] = true; }
    n.answers.push({ question_id: q.id, option_ids: optIds, seq: n.answers.length + 1, stage: q.stage });
    // Where the interview goes next: an option- or question-level `next`
    // (always forward - the compiler refuses a backward jump as a cycle), else
    // simply the next eligible question in content order.
    var target = null;
    if (q.kind !== "multi" && chosen[0].next) target = chosen[0].next;
    if (!target && q.next) target = q.next;
    n.pos = ix.qIndex[q.id];
    n.jump = null;
    if (target === "end") n.ended = true;
    else if (target) n.jump = target;
    return { state: n, question: q };
  }

  function applyEffects(ix, n, eff) {
    for (var e = 0; e < EFFECT_ORDER.length; e++) {
      var key = EFFECT_ORDER[e];
      if (!has(eff, key)) continue;
      var v = eff[key], i;
      if (key === "select_needs") { for (i = 0; i < v.length; i++) addUnique(n.needs, v[i]); }
      else if (key === "set_top_need") { n.topNeedExplicit = v; }
      else if (key === "set_facet") { var fl = isArr(v) ? v : [v]; for (i = 0; i < fl.length; i++) addUnique(n.facets, fl[i]); }
      else if (key === "set_moments") { for (i = 0; i < v.length; i++) addUnique(n.moments, v[i]); }
      else if (key === "set_experience") { n.experience = v; }
      else if (key === "advice") { for (i = 0; i < v.length; i++) addUnique(n.advice, v[i]); }
      else if (key === "exclude_product_tags") { for (i = 0; i < v.length; i++) addUnique(n.excludedTags, v[i]); }
      else if (key === "add_secondary_need") { addUnique(n.secondaryNeeds, v); }
    }
  }

  // Replay a list of answers from scratch. Used by back() and by the return-
  // visit path; returns {state, failedAt} where failedAt is the index of the
  // first answer that no longer fits the content (or -1).
  function replay(ix, answers) {
    var s = initialState();
    for (var i = 0; i < answers.length; i++) {
      var r = applyAnswer(ix, s, answers[i].question_id, answers[i].option_ids);
      if (r.error) return { state: s, failedAt: i };
      s = r.state;
    }
    return { state: s, failedAt: -1 };
  }

  // ===========================================================================
  // Ranking. Every number is a content parameter (config.yml); the SHAPE of the
  // policy is fixed here (architecture C4 steps 1-8). Integer math only.
  // ===========================================================================
  function facts(ix, s) {
    var t = topNeed(ix, s);
    var facetsOfTop = [];
    for (var i = 0; i < s.facets.length; i++) {
      var f = ix.facetById[s.facets[i]];
      if (f && f.need === t) facetsOfTop.push(s.facets[i]);
    }
    var others = [];
    for (i = 0; i < s.needs.length; i++) if (s.needs[i] !== t) others.push(s.needs[i]);
    var exp = s.experience || ix.cfg.default_experience || "novice";
    // Secondary needs (1.3.0), in the order they were added; never the top need.
    var secondary = [];
    for (i = 0; i < (s.secondaryNeeds || []).length; i++) {
      if (s.secondaryNeeds[i] !== t && has(ix.needById, s.secondaryNeeds[i])) secondary.push(s.secondaryNeeds[i]);
    }
    return { topNeed: t, facets: facetsOfTop, moments: s.moments.slice(), experience: exp,
             excludedTags: s.excludedTags.slice(), otherNeeds: others, secondaryNeeds: secondary };
  }

  // Step 1 score: the product's best answer to THEIR version of the need - the
  // max facet confidence among the facets they selected, else the need level.
  function scoreFor(p, t, facetIds) {
    if (!t || !p.needs || !has(p.needs, t)) return null;
    var best = null;
    for (var i = 0; i < facetIds.length; i++) {
      if (p.facets && has(p.facets, facetIds[i])) {
        var v = p.facets[facetIds[i]];
        if (best === null || v > best) best = v;
      }
    }
    return best !== null ? best : p.needs[t];
  }

  function momentMatches(p, moments) {
    var n = 0;
    for (var i = 0; i < moments.length; i++) if (p.moments && contains(p.moments, moments[i])) n++;
    return n;
  }

  function carriesExcludedTag(p, tags) {
    if (!p.attribute_tags) return false;
    for (var i = 0; i < p.attribute_tags.length; i++) if (contains(tags, p.attribute_tags[i])) return true;
    return false;
  }

  function otherNeedsCovered(p, others) {
    var n = 0;
    for (var i = 0; i < others.length; i++) if (p.needs && has(p.needs, others[i])) n++;
    return n;
  }

  // Family dedupe (step 3): one product per family - the format sibling that
  // fits the most of the shopper's moments, ties to the family default.
  function pickSibling(ix, siblings, F, scoreOf) {
    var list = siblings.slice().sort(function (a, b) {
      var ma = momentMatches(a, F.moments), mb = momentMatches(b, F.moments);
      if (ma !== mb) return mb - ma;
      var da = ix.famDefault[a.family] === a.id ? 1 : 0, db = ix.famDefault[b.family] === b.id ? 1 : 0;
      if (da !== db) return db - da;
      var sa = scoreOf(a), sb = scoreOf(b);
      sa = sa === null ? -1 : sa; sb = sb === null ? -1 : sb;
      if (sa !== sb) return sb - sa;
      var pa = a.priority || 0, pb = b.priority || 0;
      if (pa !== pb) return pb - pa;
      return cmpStr(a.id, b.id);
    });
    return list[0];
  }

  // Steps 1-4 + 8: every product that answers the top need, whatever its family
  // role. Since 2026-09-24 the foundation family (Master Blend) competes here on
  // its own label scores like any product; it is no longer set aside and
  // inserted at a forced rank (see startBroad for how it stays in every result).
  function needPipeline(ix, F, gated) {
    var cfg = ix.cfg, t = F.topNeed;
    if (!t) return [];
    var pool = [], i;
    // Step 1: candidates for the top need, minus anything carrying an excluded tag.
    for (i = 0; i < ix.products.length; i++) {
      var p = ix.products[i];
      if (!p.needs || !has(p.needs, t) || !p.reasons || !has(p.reasons, t)) continue;
      if (carriesExcludedTag(p, F.excludedTags)) continue;
      // Step 2: the format gate (Decision 8 - co-equal with need, not a tiebreak).
      if (gated && momentMatches(p, F.moments) === 0) continue;
      pool.push(p);
    }
    var scoreOf = function (p) { return scoreFor(p, t, F.facets); };
    // Step 3: family dedupe.
    var byFam = {}, famIds = [];
    for (i = 0; i < pool.length; i++) {
      if (!has(byFam, pool[i].family)) { byFam[pool[i].family] = []; famIds.push(pool[i].family); }
      byFam[pool[i].family].push(pool[i]);
    }
    famIds.sort(cmpStr);
    var picks = [];
    for (i = 0; i < famIds.length; i++) picks.push(pickSibling(ix, byFam[famIds[i]], F, scoreOf));
    // Step 4: the score floors (Decision 5). A product must clear BOTH the
    // absolute floor and a fraction of the best score. Both default to 0 since
    // 2026-09-24 ("grades rank; they never hide a product"), so at the defaults
    // nothing eligible is hidden by score; an operator can still raise them.
    var best = 0;
    for (i = 0; i < picks.length; i++) { var sc = scoreOf(picks[i]); if (sc > best) best = sc; }
    var absT = cfg.threshold_absolute, relT = cfg.threshold_relative_pct;
    var kept = [];
    for (i = 0; i < picks.length; i++) {
      var s = scoreOf(picks[i]);
      if (s >= absT && s * 100 >= relT * best) kept.push({ p: picks[i], score: s });
    }
    // Step 8: fully deterministic order - score, other needs covered, priority, id.
    kept.sort(function (a, b) {
      if (a.score !== b.score) return b.score - a.score;
      var oa = otherNeedsCovered(a.p, F.otherNeeds), ob = otherNeedsCovered(b.p, F.otherNeeds);
      if (oa !== ob) return ob - oa;
      var pa = a.p.priority || 0, pb = b.p.priority || 0;
      if (pa !== pb) return pb - pa;
      return cmpStr(a.p.id, b.p.id);
    });
    return kept;
  }

  // The foundation family's best sibling for the shopper's moments, never one
  // carrying an excluded tag (the compiler's sweep proves one always survives).
  function pickFoundation(ix, F) {
    var fam = ix.cfg.foundation_family, sibs = [];
    for (var i = 0; i < ix.products.length; i++) {
      var p = ix.products[i];
      if (p.family === fam && !carriesExcludedTag(p, F.excludedTags)) sibs.push(p);
    }
    if (!sibs.length) return null;
    return pickSibling(ix, sibs, F, function (p) { return scoreFor(p, F.topNeed, F.facets); });
  }

  // The ritual pick (2026-09-24, third round: "a Morning coffee answer adds
  // Coffee Booster"). A product whose row marks it `ritual_for` one of the
  // shopper's moments is ALWAYS added - whether or not another card already
  // fits that moment (the rule before this fired only for an UNSERVED moment,
  // and Master Blend powder serves coffee, so it never fired). One ritual card
  // at most; moments are tried in content order, then priority, then id.
  function ritualPick(ix, F, cards) {
    var taken = {}, i, j;
    for (i = 0; i < cards.length; i++) taken[cards[i].p.id] = true;
    for (i = 0; i < F.moments.length; i++) {
      var cands = [];
      for (j = 0; j < ix.products.length; j++) {
        var rp = ix.products[j];
        if (!rp.moment_reason || !isArr(rp.ritual_for) || !contains(rp.ritual_for, F.moments[i])) continue;
        // Already on the page as a need card: it is shown, and one product is
        // never shown twice. A sibling of its family on the page does NOT stop
        // it: Coffee Booster is a Lion's Mane product, and a focus shopper who
        // drinks coffee is exactly who the ritual pick is for.
        if (taken[rp.id]) continue;
        if (carriesExcludedTag(rp, F.excludedTags)) continue;
        cands.push(rp);
      }
      cands.sort(function (a, b) {
        var pa = a.priority || 0, pb = b.priority || 0;
        return pa !== pb ? pb - pa : cmpStr(a.id, b.id);
      });
      if (cands.length) return cands[0];
    }
    return null;
  }

  function rank(ix, F) {
    var cfg = ix.cfg;
    var kept = needPipeline(ix, F, F.moments.length > 0);
    var fallback = false;
    if (kept.length === 0 && F.moments.length > 0) {
      // The gate emptied the need set: priority 1 (a good recommendation)
      // beats format tidiness - keep the need-matched products, flag them.
      var ungated = needPipeline(ix, F, false);
      if (ungated.length) { kept = ungated; fallback = true; }
    }
    var maxResults = Math.min(cfg.max_results, 3);
    var cards = [], i;
    for (i = 0; i < kept.length && i < maxResults; i++) {
      cards.push({ p: kept[i].p, basis: "need", score: kept[i].score, fallback: fallback });
    }
    // Step 6b (1.3.0): secondary needs. Each takes ONE card after the top need's
    // cards: its best product (same pipeline, format gate first, ungated as the
    // flagged fallback) whose product and family are not already on the page.
    // With every slot full it replaces the lowest need card ONLY when at least
    // two need cards exist, so the top need is always answered by a card.
    var sec = F.secondaryNeeds || [];
    for (var si = 0; si < sec.length; si++) {
      var F2 = { topNeed: sec[si], facets: [], moments: F.moments, experience: F.experience,
                 excludedTags: F.excludedTags, otherNeeds: [], secondaryNeeds: [] };
      var sk = needPipeline(ix, F2, F.moments.length > 0), sfb = false;
      if (sk.length === 0 && F.moments.length > 0) { sk = needPipeline(ix, F2, false); sfb = sk.length > 0; }
      var onPage = {}, famOn = {};
      for (i = 0; i < cards.length; i++) { onPage[cards[i].p.id] = true; famOn[cards[i].p.family] = true; }
      var pick = null;
      for (i = 0; i < sk.length; i++) if (!onPage[sk[i].p.id] && !famOn[sk[i].p.family]) { pick = sk[i]; break; }
      if (!pick) continue;
      if (cards.length >= maxResults) {
        var needCount = 0;
        for (i = 0; i < cards.length; i++) if (cards[i].basis === "need") needCount++;
        if (needCount < 2) continue;
        for (i = cards.length - 1; i >= 0; i--) if (cards[i].basis === "need") { cards.splice(i, 1); break; }
      }
      cards.push({ p: pick.p, basis: "secondary", need: sec[si], score: pick.score, fallback: sfb });
    }
    // Step 7: the ritual slot. The ritual card sits LAST. The capacity rule
    // (review finding 3): with room, it is added; with every slot full, it
    // replaces the lowest-scored need card ONLY when at least two need cards
    // exist, so the shopper's need is always answered by at least one card;
    // otherwise (max_results 1, one need card) the ritual is skipped.
    if (cfg.ritual_slot && F.moments.length) {
      var rp = ritualPick(ix, F, cards);
      if (rp) {
        if (cards.length >= maxResults && cards.length >= 2) {
          for (i = cards.length - 1; i >= 0; i--) if (cards[i].basis === "need") { cards.splice(i, 1); break; }
        }
        if (cards.length < maxResults) cards.push({ p: rp, basis: "ritual", score: null, fallback: false });
      }
    }
    return cards;
  }

  // "Or start broad" (2026-09-24, fourth round, amending Decision 7): Master
  // Blend stays in EVERY result without being forced to rank one. When no
  // foundation product earned a card on its own scores, the model names the
  // family's best sibling for the shopper's moments here, separately; when one
  // did, this is null (never shown twice). The experience answer still does
  // something: it sets the emphasis, and the page decides how to render it.
  function startBroad(ix, F, cards) {
    var fam = ix.cfg.foundation_family;
    for (var i = 0; i < cards.length; i++) if (cards[i].p.family === fam) return null;
    var p = pickFoundation(ix, F);
    if (!p) return null;
    return { p: p, emphasis: F.experience === "experienced" ? "follow" : "lead" };
  }

  // ===========================================================================
  // Result composition - the C9 model the page (wi-2026-0999) consumes.
  // ===========================================================================
  function reasonFor(ix, card, t) {
    var p = card.p, fid = null;
    if (card.basis === "need") fid = (p.reasons && t) ? p.reasons[t] : null;
    else if (card.basis === "secondary") fid = (p.reasons && card.need) ? p.reasons[card.need] : null;
    else if (card.basis === "ritual") fid = p.moment_reason;
    else if (card.basis === "start_broad") {
      // 1.3.0: the foundation line for the shopper's top need, else the plain line.
      fid = (p.foundation_reasons && t && has(p.foundation_reasons, t)) ? p.foundation_reasons[t] : p.foundation_reason;
    }
    var f = fid ? ix.frags[fid] : null;
    return { fragment_id: fid || null, kind: f ? f.kind : null,
             register_ref: f && f.register_ref ? f.register_ref : null, text: f ? f.text : "" };
  }

  function vocabLabel(ix, group, key) {
    var v = ix.c.vocab && ix.c.vocab[group];
    if (!key || !v || !has(v, key)) return "";
    return fragText(ix, v[key]);
  }

  function composeCards(ix, cards, t, answered, offset) {
    var out = [];
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i], p = c.p;
      out.push({
        rank: i + 1,
        basis: c.basis,
        product: { id: p.id, handle: p.handle, variant_id: p.variant_id, family: p.family,
                   species: p.species || null, format: p.format },
        // 1.4.0 (Nate 2026-09-28): the card's name, for "Choose <name>", and the plain
        // formats line: every format the family ships, in the content's order.
        name: p.display_name || null,
        // 1.4.0: the approved "Here's why we picked it" paragraph for this card:
        // position (match | option) + the top need + the answers it depends on.
        why: whyOf(ix, p, (offset || 0) + i + 1, t, answered),
        formats: familyFormats(ix, p),
        reason: reasonFor(ix, c, t),
        // 1.3.0: the per-format fit line ("Take them with water, any time of day.").
        // Non-claim copy beside the claim line; null when the row names none.
        fit: fitOf(ix, p, t),
        // 1.3.0: the product's label line (a claim fragment) when the row names
        // one; the start_broad block's label line. null otherwise.
        label_line: labelLineOf(ix, p),
        // 1.3.0: a sibling format the card links to (Coffee Booster -> Lion's Mane
        // powder), with its approved line; null when none or the target is gone.
        also_as: alsoAsOf(ix, p),
        confidence: (typeof c.score === "number") ? c.score : null,
        time_to_effect: { key: p.time_to_effect || null, label: vocabLabel(ix, "time_to_effect", p.time_to_effect) },
        door: p.door ? { key: p.door, label: vocabLabel(ix, "doors", p.door), start_here: !!p.door_start_here } : null,
        add: { variant_id: p.variant_id, quantity: 1 },
        // The product's label warning (2026-09-24: Sleep and Master Blend show
        // theirs). Non-claim copy, never touched by the claim gate.
        warning: warningOf(ix, p),
        flags: { format_fallback: !!c.fallback }
      });
    }
    return out;
  }

  // The most specific approved paragraph whose `when` answers the shopper all gave.
  function whyOf(ix, p, rank, t, answered) {
    answered = answered || {};
    var list = ix.whys[p.id + "|" + (rank === 1 ? "match" : "option") + "|" + t] || [];
    var best = null, bestLen = -1;
    for (var i = 0; i < list.length; i++) {
      var w = list[i], ok = true;
      for (var j = 0; j < w.when.length; j++) if (!answered[w.when[j]]) { ok = false; break; }
      if (ok && w.when.length > bestLen) { best = w; bestLen = w.when.length; }
    }
    return best ? { text: best.text } : null;
  }

  function familyFormats(ix, p) {
    var order = ix.cfg.format_order || [], seen = {}, out = [];
    for (var i = 0; i < ix.products.length; i++) {
      var q = ix.products[i];
      if (q.family !== p.family || !q.format_label || seen[q.format_label]) continue;
      seen[q.format_label] = true;
      out.push(q.format_label);
    }
    out.sort(function (a, b) {
      var ia = order.indexOf(a), ib = order.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || (a < b ? -1 : a > b ? 1 : 0);
    });
    return out;
  }

  function alsoAsOf(ix, p) {
    var t = p.also_as ? ix.prodById[p.also_as] : null, f = p.also_as_ref ? ix.frags[p.also_as_ref] : null;
    if (!t || !f || !f.text) return null;
    return { fragment_id: p.also_as_ref, text: f.text,
             product: { id: t.id, handle: t.handle, variant_id: t.variant_id, format: t.format } };
  }

  // The fit line. A FOUNDATION product's fit line is its foundation line for the
  // shopper's top need (plain line as fallback), Nate 2026-09-27; every other
  // product's is its per-format fit_ref.
  function fitOf(ix, p, t) {
    var fid = p.fit_ref || null;
    if (p.family_role === "foundation" && p.foundation_reason) {
      fid = (p.foundation_reasons && t && has(p.foundation_reasons, t)) ? p.foundation_reasons[t] : p.foundation_reason;
    }
    var f = fid ? ix.frags[fid] : null;
    return (f && f.text) ? { fragment_id: fid, text: f.text } : null;
  }

  function labelLineOf(ix, p) {
    var f = p.label_line_ref ? ix.frags[p.label_line_ref] : null;
    return (f && f.text) ? { fragment_id: p.label_line_ref, text: f.text, register_ref: f.register_ref || null } : null;
  }

  function warningOf(ix, p) {
    var f = p.warning_ref ? ix.frags[p.warning_ref] : null;
    return (f && f.text) ? { fragment_id: p.warning_ref, text: f.text } : null;
  }

  // The start_broad block: the same shape as a card (so a page renders it with
  // the same code), minus a rank, plus the emphasis.
  function composeStartBroad(ix, sb, t, answered, nCards) {
    if (!sb) return null;
    // Rendered after the cards, so its why is an OPTION paragraph.
    var out = composeCards(ix, [{ p: sb.p, basis: "start_broad", score: null, fallback: false }], t || null,
                           answered || {}, Math.max(1, nCards || 1))[0];
    delete out.rank;
    out.emphasis = sb.emphasis;
    return out;
  }

  // The caution line every result carries (2026-09-24: a check-with-your-doctor
  // line instead of any health question, so nothing sensitive is collected).
  function caution(ix) {
    var id = ix.cfg.caution_ref, f = id ? ix.frags[id] : null;
    return (f && f.text) ? { fragment_id: id, text: f.text } : null;
  }

  function joinList(items, joiner, lastJoiner) {
    if (items.length <= 1) return items.join("");
    return items.slice(0, -1).join(joiner) + lastJoiner + items[items.length - 1];
  }

  // The readback (Decision 3's last stage) is TEMPLATE ASSEMBLY of the
  // shopper's own answer phrases - concatenation, never a model call.
  function readback(ix, s) {
    var parts = [], i, j;
    for (i = 0; i < s.answers.length; i++) {
      var a = s.answers[i];
      for (j = 0; j < a.option_ids.length; j++) {
        var o = ix.optById[a.option_ids[j]];
        if (o && o.readback_ref) {
          var ph = fragText(ix, o.readback_ref);
          if (ph) parts.push({ option_id: o.id, phrase: ph });
        }
      }
    }
    var rc = ix.cfg.readback || {};
    var phrases = [];
    for (i = 0; i < parts.length; i++) phrases.push(parts[i].phrase);
    var body = joinList(phrases, rc.joiner || ", ", rc.last_joiner || " and ");
    var segs = [];
    if (body) {
      if (rc.intro_ref && fragText(ix, rc.intro_ref)) segs.push(fragText(ix, rc.intro_ref));
      segs.push(body);
      if (rc.outro_ref && fragText(ix, rc.outro_ref)) segs.push(fragText(ix, rc.outro_ref));
    }
    return { text: segs.join(" "), parts: parts };
  }

  // Advice (Decision 10): when a boundary answer names a bigger lever than any
  // product, it LEADS. The model orders its own sections so a page that renders
  // in order satisfies SC-8 by construction.
  function advice(ix, s) {
    var lead = [], rest = [];
    for (var i = 0; i < s.advice.length; i++) {
      var f = ix.frags[s.advice[i]];
      if (!f || !f.text) continue;
      var item = { id: s.advice[i], text: f.text, lead: !!f.lead };
      if (item.lead) lead.push(item); else rest.push(item);
    }
    return lead.concat(rest);
  }

  function labelOfNeed(ix, id) {
    var n = ix.needById[id];
    return { id: id, label: n ? fragText(ix, n.label_ref) : "" };
  }

  function buildResult(ix, s, meta) {
    meta = meta || {};
    var F = facts(ix, s);
    var ranked = rank(ix, F);
    var answered = {};
    for (var ai = 0; ai < s.answers.length; ai++)
      for (var aj = 0; aj < s.answers[ai].option_ids.length; aj++) answered[s.answers[ai].option_ids[aj]] = true;
    var cards = composeCards(ix, ranked, F.topNeed, answered);
    var sb = startBroad(ix, F, ranked);
    var adv = advice(ix, s);
    var leadAdvice = false;
    for (var i = 0; i < adv.length; i++) if (adv[i].lead) leadAdvice = true;
    // No "take all three" (2026-09-24, amending Decision 5): each card keeps its
    // own add action and nothing implies a stack.
    var others = [];
    for (i = 0; i < F.otherNeeds.length; i++) others.push(labelOfNeed(ix, F.otherNeeds[i]));
    return {
      schema: RESULT_SCHEMA,
      quiz_response_id: meta.responseId || null,
      content_version: ix.c.version || null,
      engine_version: ENGINE_VERSION,
      entry_point: meta.entryPoint || null,
      readback: readback(ix, s),
      lead_with_advice: leadAdvice,
      advice: adv,
      sections: leadAdvice ? ["readback", "advice", "recommendations"] : ["readback", "recommendations", "advice"],
      recommendations: cards,
      start_broad: composeStartBroad(ix, sb, F.topNeed, answered, ranked.length),
      caution: caution(ix),
      needs: { top: F.topNeed ? labelOfNeed(ix, F.topNeed) : null, others: others },
      facets: F.facets,
      moments: F.moments,
      experience: F.experience,
      email_gate: meta.emailGate || "pending",
      link: { status: "pending", url: null },
      result_changed: !!meta.resultChanged,
      source: meta.source || "live"
    };
  }

  // ===========================================================================
  // The session - the page-facing object. Holds the answer list; everything
  // else is recomputed from it, so there is no drift between views.
  // ===========================================================================
  function stageNumber(stage) {
    for (var i = 0; i < STAGES.length; i++) if (STAGES[i] === stage) return i + 1;
    return 0;
  }

  function Session(content, opts) {
    this._ix = null;
    this._unavailableReason = null;
    if (content) {
      try { this._ix = indexContent(content); }
      catch (e) { this._ix = null; this._unavailableReason = e && e.code ? e.code : "malformed"; }
    } else {
      this._unavailableReason = "no_content";
    }
    this._entry = (opts && opts.entryPoint) || null;
    this._rid = (opts && opts.responseId) || null;
    this._s = initialState();
    this._revisions = {};
    this._gate = null;
    this._lastError = null;
    this._result = null;
  }

  Session.prototype._phase = function () {
    if (!this._ix) return "unavailable";
    if (nextQuestion(this._ix, this._s)) return "interview";
    if (this._ix.cfg.email_gate && this._gate === null) return "gate";
    return "result";
  };

  Session.prototype._view = function () {
    var phase = this._phase(), q = null, ix = this._ix;
    if (phase === "interview") {
      var cur = nextQuestion(ix, this._s), vis = visibleOptions(ix, this._s, cur), opts = [];
      for (var i = 0; i < vis.length; i++) {
        opts.push({ id: vis[i].id, label: fragText(ix, vis[i].label_ref), exclusive: !!vis[i].exclusive });
      }
      q = { id: cur.id, stage: cur.stage, kind: cur.kind, prompt: fragText(ix, cur.prompt_ref),
            options: opts, max_select: cur.kind === "multi" ? (cur.max_select || opts.length) : 1 };
    }
    var answered = this._s.answers.length;
    return {
      phase: phase,
      stepIndex: answered,
      question: q,
      canGoBack: answered > 0 && phase !== "unavailable",
      // Progress WITHOUT a promised total (C9 page constraint 5): the path is
      // six to nine questions depending on answers, so we expose the stage and
      // the count answered, never "N of M".
      progressHint: { answered: answered, stage: q ? q.stage : null,
                      stage_number: q ? stageNumber(q.stage) : STAGES.length, stages_total: STAGES.length },
      error: this._lastError,
      unavailable_reason: phase === "unavailable" ? this._unavailableReason : null
    };
  };

  Session.prototype.answer = function (questionId, optionIds) {
    if (!this._ix) return this._view();
    var r = applyAnswer(this._ix, this._s, questionId, optionIds);
    if (r.error) { this._lastError = r.error; return this._view(); }
    this._revisions[questionId] = (this._revisions[questionId] || 0) + 1;
    var last = r.state.answers[r.state.answers.length - 1];
    last.revision = this._revisions[questionId];
    this._s = r.state;
    this._lastError = null;
    this._result = null;
    return this._view();
  };

  Session.prototype.back = function () {
    if (!this._ix || this._s.answers.length === 0) return this._view();
    if (this._gate !== null) { this._gate = null; }
    var kept = this._s.answers.slice(0, -1);
    var rp = replay(this._ix, kept);
    // Keep the revision stamps of the answers we kept.
    for (var i = 0; i < rp.state.answers.length; i++) rp.state.answers[i].revision = kept[i].revision;
    this._s = rp.state;
    this._lastError = null;
    this._result = null;
    return this._view();
  };

  // Decision 16: the email gate sits after the questions and before the reveal
  // and is genuinely skippable - the result never depends on it.
  Session.prototype.completeGate = function (o) {
    if (this._phase() === "gate") this._gate = (o && o.given) ? "given" : "skipped";
    this._result = null;
    return this._view();
  };

  Session.prototype._resultModel = function () {
    var phase = this._phase();
    if (phase === "interview" || phase === "unavailable") return null;
    if (!this._result) {
      var gate = this._ix.cfg.email_gate ? (this._gate || "pending") : "not_offered";
      this._result = buildResult(this._ix, this._s, { responseId: this._rid, entryPoint: this._entry, emailGate: gate });
    }
    return this._result;
  };

  Session.prototype._answersOut = function () {
    var out = [];
    for (var i = 0; i < this._s.answers.length; i++) {
      var a = this._s.answers[i];
      out.push({ question_id: a.question_id, option_ids: a.option_ids.slice(), seq: a.seq,
                 stage: a.stage, revision: a.revision || 1 });
    }
    return out;
  };

  Object.defineProperty(Session.prototype, "state", { get: function () { return this._view(); } });
  Object.defineProperty(Session.prototype, "result", { get: function () { return this._resultModel(); } });
  Object.defineProperty(Session.prototype, "answers", { get: function () { return this._answersOut(); } });
  Object.defineProperty(Session.prototype, "topNeed", { get: function () { return this._ix ? topNeed(this._ix, this._s) : null; } });

  // ===========================================================================
  // The return visit (ADR-16, as amended by validation F-002).
  //
  // The emailed link resolves to the stored result's IDS ONLY — which products,
  // which reason fragment for each, which advice — never the shopper's answers,
  // readback or needs, because a result token is a bearer credential that
  // rides a URL third-party scripts can read. So the model is REBUILT from those
  // ids on CURRENT content:
  //   - a card whose product is no longer eligible is dropped;
  //   - a card whose reason fragment is gone, or changed kind (a retracted
  //     claim), is dropped rather than given a reason the model did not supply
  //     (C9 page constraint 6);
  //   - advice keeps only fragments that still exist, with today's wording;
  //   - nothing is re-ranked (there are no answers to re-rank from);
  //   - readback, needs, moments and experience are empty: the return page
  //     never repeats the shopper's own words back to whoever holds the link;
  //   - if no card survives, `retake` invites the shopper to take it again.
  // A returning shopper therefore never sees a discontinued product or a
  // since-retracted claim (Decision 0, priority 1), and learns nothing a
  // bearer could not.
  //
  // Since 1.2.0 (2026-09-24):
  //   - what was dropped is COUNTED, never silent: `dropped.unavailable` (the
  //     product is no longer in the published content) and
  //     `dropped.reason_changed` (its reason is gone or changed kind);
  //   - an expired link (the host answers 410 after 90 days; the client passes
  //     {expired: true}) returns the same retake model with `expired: true`;
  //   - the caution line rides the return model too; start_broad is the
  //     product originally offered (by id), kept while it is still in the
  //     content, NEVER re-picked; when it cannot be kept the model asks for a
  //     retake (default emphasis: the return knows no experience).
  // ===========================================================================
  function resolveReturn(view, content) {
    var ix;
    try { ix = indexContent(content); } catch (e) { return null; }
    view = view || {};
    var expired = view.expired === true;
    var res = (!expired && view.result && typeof view.result === "object") ? view.result : {};
    var model = buildResult(ix, initialState(), { responseId: view.quiz_response_id || null,
                                                  entryPoint: null, emailGate: "not_offered" });
    model.source = "return";
    model.readback = { text: "", parts: [] };
    model.needs = { top: null, others: [] };
    model.facets = [];
    model.moments = [];
    model.experience = null;

    // Advice: still-existing fragments only, today's text, lead-first ordering.
    var ids = isArr(res.advice_ids) ? res.advice_ids : [], lead = [], rest = [], i;
    for (i = 0; i < ids.length; i++) {
      var af = typeof ids[i] === "string" ? ix.frags[ids[i]] : null;
      if (!af || af.kind !== "advice" || !af.text) continue;
      var item = { id: ids[i], text: af.text, lead: !!af.lead };
      if (item.lead) lead.push(item); else rest.push(item);
    }
    model.advice = lead.concat(rest);
    model.lead_with_advice = lead.length > 0;
    model.sections = model.lead_with_advice ? ["advice", "recommendations"] : ["recommendations", "advice"];

    // Cards: still-eligible products whose reason still exists as the same kind.
    var cards = isArr(res.cards) ? res.cards : [], kept = [];
    var droppedUnavailable = 0, droppedReason = 0;
    for (i = 0; i < cards.length && kept.length < 3; i++) {
      var c = cards[i] || {};
      var p = typeof c.product_id === "string" ? ix.prodById[c.product_id] : null;
      if (!p) { droppedUnavailable++; continue; }
      var fid = typeof c.reason_fragment_id === "string" ? c.reason_fragment_id : null;
      var f = fid ? ix.frags[fid] : null;
      if (!f || !f.text || (c.reason_kind && f.kind !== c.reason_kind)) { droppedReason++; continue; }
      kept.push({ p: p, basis: c.basis, score: null, fallback: !!c.format_fallback, fid: fid });
    }
    var out = [];
    for (i = 0; i < kept.length; i++) {
      var composed = composeCards(ix, [kept[i]], null)[0];
      var fr = ix.frags[kept[i].fid];
      composed.reason = { fragment_id: kept[i].fid, kind: fr.kind, register_ref: fr.register_ref || null, text: fr.text };
      composed.rank = i + 1;
      out.push(composed);
    }
    model.recommendations = out;
    // start_broad is the product the shopper was ORIGINALLY offered, by id, never
    // re-picked (review finding 2): the return knows none of the shopper's
    // exclusions or moments, so a fresh pick could offer a sibling they ruled
    // out. Kept only while it is still a foundation product in the published
    // content and no surviving card is already one (never shown twice). The
    // emphasis is the content default: the return knows no experience answer.
    var fam = ix.cfg.foundation_family, mbCard = false, sbGone = false, sbKept = null;
    for (i = 0; i < kept.length; i++) if (kept[i].p.family === fam) mbCard = true;
    var sbId = (res.start_broad && typeof res.start_broad.product_id === "string") ? res.start_broad.product_id : null;
    if (sbId && !mbCard) {
      var sbp = ix.prodById[sbId];
      if (sbp && sbp.family === fam) {
        sbKept = { p: sbp, emphasis: (ix.cfg.default_experience === "experienced") ? "follow" : "lead" };
      } else { sbGone = true; droppedUnavailable++; }
    }
    model.start_broad = composeStartBroad(ix, sbKept);
    model.dropped = { unavailable: droppedUnavailable, reason_changed: droppedReason };
    // Anything dropped means the shopper sees less than they were sent.
    model.result_changed = out.length !== cards.length || model.advice.length !== ids.length || sbGone;
    // Invite a retake when nothing survived, when the link expired, or when
    // Master Blend can no longer be shown without guessing a sibling (the
    // offered start_broad is gone, or the stored result named none and no
    // foundation card survived): a retake is safe, a re-pick is not.
    model.retake = out.length === 0 || (!mbCard && !sbKept);
    model.expired = expired;
    return model;
  }

  // ===========================================================================
  // Loading, and the fail-open ladder (ADR-5, PT-8).
  // ===========================================================================
  function load(contentJson) {
    var obj = contentJson;
    if (typeof contentJson === "string") {
      try { obj = JSON.parse(contentJson); }
      catch (e) { throw new ContentError("parse_failed", "content is not valid JSON"); }
    }
    if (!obj || typeof obj !== "object") throw new ContentError("not_object", "content is empty");
    if (obj.schema !== CONTENT_SCHEMA) throw new ContentError("schema_unsupported", "unsupported content schema: " + obj.schema);
    if (typeof obj.version !== "string" || obj.version.length !== 12) throw new ContentError("no_version", "content has no version");
    var full = contentHash(obj);
    if (full.slice(0, 12) !== obj.version) throw new ContentError("hash_mismatch", "content was edited after it was compiled");
    indexContent(obj);   // throws ContentError on a structural fault
    return obj;
  }

  function loadLadder(o) {
    o = o || {};
    var errors = [];
    if (o.quiz_live != null && String(o.quiz_live).toLowerCase() === "off") {
      return { content: null, source: "killed", errors: [] };
    }
    var ptr = o.pointer || null;
    try {
      var c = load(o.content);
      if (ptr && ptr.version && ptr.version !== c.version) throw new ContentError("pointer_mismatch", "pointer names a different version");
      if (ptr && ptr.sha256 && ptr.sha256 !== contentHash(c)) throw new ContentError("pointer_mismatch", "pointer hash differs");
      return { content: c, source: "content", errors: errors };
    } catch (e1) {
      errors.push({ key: "content", code: e1 && e1.code ? e1.code : "error" });
    }
    try {
      var p = load(o.content_prev);
      return { content: p, source: "content_prev", errors: errors };
    } catch (e2) {
      errors.push({ key: "content_prev", code: e2 && e2.code ? e2.code : "error" });
    }
    return { content: null, source: "none", errors: errors };
  }

  function create(o) {
    o = o || {};
    return new Session(o.content || null, { entryPoint: o.entryPoint, responseId: o.responseId });
  }

  // ===========================================================================
  // Public surface.
  // ===========================================================================
  var OmQuiz = {
    VERSION: { engine: ENGINE_VERSION, content_schema: CONTENT_SCHEMA, result_schema: RESULT_SCHEMA },
    ContentError: ContentError,
    load: load,
    loadLadder: loadLadder,
    create: create,
    resolveReturn: resolveReturn,
    contentHash: contentHash,
    canonicalJson: canonicalJson,
    sha256Hex: sha256Hex,
    // Pure internals, exported for the Node selftest and the compiler's sweep.
    // The browser never needs them; they are part of the same one engine.
    _internal: {
      indexContent: indexContent, initialState: initialState, nextQuestion: nextQuestion,
      visibleOptions: visibleOptions, applyAnswer: applyAnswer, replay: replay, topNeed: topNeed,
      facts: facts, rank: rank, startBroad: startBroad, buildResult: buildResult, evalPred: evalPred,
      STAGES: STAGES
    }
  };

  if (typeof module !== "undefined" && module.exports) {
    module.exports = OmQuiz;
  } else {
    root.OmQuiz = OmQuiz;
  }
})(this);
